<template>
  <div class="margin-top-sm">
    <el-row>
      <el-col :span="3">
        <el-date-picker v-model="dataReportEarnedDetailStatisticsInfo.startDate" type="date"
          :placeholder="$t('dataReport.startDate')" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-col>
      <el-col :span="3">
        <el-date-picker v-model="dataReportEarnedDetailStatisticsInfo.endDate" type="date"
          :placeholder="$t('dataReport.endDate')" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-col>
      <el-col :span="3">
        <el-input v-model="dataReportEarnedDetailStatisticsInfo.objName" :placeholder="$t('dataReport.roomNumber')"
          clearable />
      </el-col>
      <el-col :span="3">
        <el-input v-model="dataReportEarnedDetailStatisticsInfo.ownerName" :placeholder="$t('dataReport.ownerName')"
          clearable />
      </el-col>
      <el-col :span="3">
        <el-input v-model="dataReportEarnedDetailStatisticsInfo.link" :placeholder="$t('dataReport.phoneNumber')"
          clearable />
      </el-col>
      <el-col :span="3">
        <el-button type="primary" size="small" @click="_qureyDataReportEarnedDetailStatistics">
          <i class="el-icon-search"></i>
          {{ $t('dataReport.search') }}
        </el-button>
      </el-col>
      <el-col :span="6" class="text-right">
        <el-button type="primary" size="small" @click="_exportReportEarnedDetailExcel">
          <i class="el-icon-download"></i>
          <span>{{ $t('dataReport.export') }}</span>
        </el-button>
      </el-col>
    </el-row>

    <div class="margin-top-sm">
      <el-table :data="dataReportEarnedDetailStatisticsInfo.fees" border style="width: 100%">
        <el-table-column prop="roomName" :label="$t('dataReport.room')" align="center" />
        <el-table-column :label="$t('dataReport.owner')" align="center">
          <template slot-scope="scope">
            {{ scope.row.ownerName }}({{ scope.row.link }})
          </template>
        </el-table-column>
        <el-table-column :label="$t('dataReport.receivedFee')" align="center">
          <template slot-scope="scope">
            {{ scope.row.receivedFee || 0 }}
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in dataReportEarnedDetailStatisticsInfo.feeTypeCds" :key="index"
          :label="item.name" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row['receivedFee' + item.statusCd]">
              <div v-for="(feeItem, fIndex) in scope.row['receivedFee' + item.statusCd]" :key="fIndex">
                {{ feeItem.feeName }}({{ feeItem.startTime }}~{{ feeItem.endTime }})={{ feeItem.receivedAmount }}
              </div>
            </div>
            <div v-else>
              0
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="24" class="text-right">
          <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getDict } from '@/api/community/communityApi'
import { queryReceivedDetailStatistics, exportData } from '@/api/report/dataReportApi'

export default {
  name: 'DataReportEarnedDetailStatistics',

  data() {
    return {
      dataReportEarnedDetailStatisticsInfo: {
        fees: [],
        feeTypeCds: [],
        objName: '',
        ownerName: '',
        link: '',
        feeAmount: '0',
        startDate: '',
        endDate: ''
      },
      communityId: '',
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    open(_param) {
      this.communityId = _param.communityId
      const now = new Date()
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1)
      const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      this.dataReportEarnedDetailStatisticsInfo.startDate = this._formatDate(startDate)
      this.dataReportEarnedDetailStatisticsInfo.endDate = this._formatDate(endDate)
      this._loadDataReportEarnedDetailStatisticsData(this.page.current, this.page.size)
    },
    _formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return year + '-' + month + '-' + day
    },
    async _initMethod() {
      try {
        const data = await getDict('pay_fee_config', 'fee_type_cd_show')
        this.dataReportEarnedDetailStatisticsInfo.feeTypeCds = data
      } catch (error) {
        console.error('Failed to load dictionary:', error)
      }
    },
    async _loadDataReportEarnedDetailStatisticsData(_page, _row) {
      try {
        const params = {
          communityId: this.communityId,
          startDate: this.dataReportEarnedDetailStatisticsInfo.startDate,
          endDate: this.dataReportEarnedDetailStatisticsInfo.endDate,
          objName: this.dataReportEarnedDetailStatisticsInfo.objName,
          ownerName: this.dataReportEarnedDetailStatisticsInfo.ownerName,
          link: this.dataReportEarnedDetailStatisticsInfo.link,
          page: _page,
          row: _row
        }
        const { data, records } = await queryReceivedDetailStatistics(params)
        this.dataReportEarnedDetailStatisticsInfo.fees = data
        this.page.total = records
      } catch (error) {
        console.error('Failed to load data:', error)
      }
    },
    _qureyDataReportEarnedDetailStatistics() {
      this.page.current = 1
      this._loadDataReportEarnedDetailStatisticsData(this.page.current, this.page.size)
    },
    async _exportReportEarnedDetailExcel() {
      try {
        const params = {
          communityId: this.communityId,
          startDate: this.dataReportEarnedDetailStatisticsInfo.startDate,
          endDate: this.dataReportEarnedDetailStatisticsInfo.endDate,
          objName: this.dataReportEarnedDetailStatisticsInfo.objName,
          ownerName: this.dataReportEarnedDetailStatisticsInfo.ownerName,
          link: this.dataReportEarnedDetailStatisticsInfo.link,
          pagePath: 'dataReportEarnedDetailStatistics'
        }
        const res = await exportData(params)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
        }
      } catch (error) {
        console.error('Export failed:', error)
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this._loadDataReportEarnedDetailStatisticsData(this.page.current, val)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._loadDataReportEarnedDetailStatisticsData(val, this.page.size)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.margin-top-lg {
  margin-top: 30px;
}

.text-right {
  text-align: right;
}
</style>